var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { SectionTitle, ListField } from "@components";
import { useAppDispatch, useAppSelector } from "@hooks";
import { setCV, showNotification, translateSubstring } from "@store";
import { HeadingIds } from "@constants";
import { createDisplayPoint } from "@utils";
import { fields } from "./localization";
import commonStyles from "../../CV.common.scss";
const POINTS_LIMIT = 7;
export function PersonalStrengths() {
    var _a;
    const dispatch = useAppDispatch();
    const { cv } = useAppSelector((state) => state.cv);
    const { language } = useAppSelector((state) => state.ui);
    const personalStrengths = ((_a = cv === null || cv === void 0 ? void 0 : cv.personalStrengthsDisplay) === null || _a === void 0 ? void 0 : _a.length)
        ? cv === null || cv === void 0 ? void 0 : cv.personalStrengthsDisplay
        : [createDisplayPoint()];
    const hidePersonalStrengths = (cv === null || cv === void 0 ? void 0 : cv.hidePersonalStrengths) || false;
    const { notification, title, placeholder, addItem } = fields(language);
    // TODO this operations are duplicated several times. Extraction make sense.
    const setValue = (personalStrengthsDisplay) => {
        dispatch(setCV(Object.assign(Object.assign({}, cv), { personalStrengthsDisplay })));
    };
    const handleLimitAchieved = () => {
        dispatch(showNotification({
            message: notification.replace("$LIMIT$", POINTS_LIMIT.toString()),
        }));
    };
    const handleAdd = () => {
        if (personalStrengths.length === 0) {
            setValue([createDisplayPoint(), createDisplayPoint()]);
        }
        else if (personalStrengths.length >= POINTS_LIMIT) {
            handleLimitAchieved();
        }
        else {
            setValue([...personalStrengths, createDisplayPoint()]);
        }
    };
    const handleItemTranslation = (itemIndex, text, start, end) => __awaiter(this, void 0, void 0, function* () {
        const translatedResult = yield dispatch(translateSubstring({ text, start, end })).unwrap();
        setValue(personalStrengths.map((point, i) => {
            if (i === itemIndex) {
                return Object.assign(Object.assign({}, point), { value: translatedResult });
            }
            return point;
        }));
    });
    return (React.createElement("section", { id: HeadingIds.PersonalStrengths, className: commonStyles.section },
        React.createElement(SectionTitle, { title: title, handleAdd: handleAdd, addButtonLabel: addItem, isSectionHidden: hidePersonalStrengths, handleSectionHide: () => {
                dispatch(setCV(Object.assign(Object.assign({}, cv), { hidePersonalStrengths: !hidePersonalStrengths })));
            } }),
        React.createElement(ListField, { title: title, itemTitle: placeholder, points: personalStrengths, onEdit: setValue, readOnly: hidePersonalStrengths, showAddBtn: false, maxLimit: POINTS_LIMIT, onLimitAchieved: handleLimitAchieved, onItemSelection: handleItemTranslation })));
}
